import React, { useState } from "react";
import "./ReadMore.scss";

const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <p className="text">
            {isReadMore ? text.slice(0, 250) : text}
            <span onClick={toggleReadMore} className="read-or-hide">
                {isReadMore ? "...Read More" : " Show Less"}
            </span>
        </p>
    );
};

const ReadMoreContent = ({ description }) => {
    return (
        <div id="read_more_container">
            <h2>
                <ReadMore>
                    {description}
                </ReadMore>
            </h2>
        </div>
    );
};

export default ReadMoreContent;
